import React, {Component} from 'react';
import PropTypes from 'prop-types';
class CommesseListTypeButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let classNameLista = "ui " + (this.props.listType === 'l' ? "positive" : "") + " button"
        let classNameReport = "ui " + (this.props.listType === 'r' ? "positive" : "") + " button"

        return (
        <div className="ui buttons">
            <button className={classNameLista} onClick={() => this.props.onButtonClick('l')}>Lista</button>
            <div className="or" data-text="o"></div>
            <button className={classNameReport} onClick={() => this.props.onButtonClick('r')}>Report</button>
        </div>
        )
    }
}
CommesseListTypeButton.PropTypes = {
    listType: PropTypes.oneOf(['l', 's']).isRequired, // l: List r:Report
    iconSize: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired // argomento:  listType: l/r
}

CommesseListTypeButton.defaultProps = {
    iconSize: ""
};

export default CommesseListTypeButton;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseListTypeButton.jsx
 **/